import api from './api';

export const salesCashLiquidationService = {
  async list(params = {}) {
    const response = await api.get('/ventas/cash-liquidations', { params });
    return response.data;
  },

  async get(params = {}) {
    const response = await api.get('/ventas/cash-liquidation', { params });
    return response.data;
  },

  async save(payload) {
    const response = await api.put('/ventas/cash-liquidation', payload);
    return response.data;
  },
};

export default salesCashLiquidationService;
